<template>
  <nav>
    <v-app-bar max-height="150" color="#F6F7FF" app flat>
      <v-app-bar-nav-icon
        small
        color="primary"
        @click="drawer = !drawer"
        class="pa-5"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <div>
        <v-btn text class="text-capitalize" color="#F46A1D" @click="logout()"
          >Logout <v-icon>mdi-logout</v-icon></v-btn
        >
      </div>
    </v-app-bar>
    <v-navigation-drawer app fullscreen v-model="drawer" temporary>
      <v-layout column align-center>
        <v-flex class="">
          <div class="d-flex justify-center align-center py-2 my-0">
            <v-img src="../assets/logo.png" width="150"></v-img>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="mt-2" color="#F6F7FF"></v-divider>

      <v-list dense>
        <v-list-item to="/home" color="orange">
          <v-list-item-icon>
            <v-icon color="primary">mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title> Dashboard </v-list-item-title>
        </v-list-item>

        <v-list-group
          v-model="active1"
          prepend-icon="mdi-alpha-p-box"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Products</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/addProduct" color="orange" v-if="getUser.role === 'admin'">
            <v-list-item-content>
              <v-list-item-title>Add product</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/product" color="orange">
            <v-list-item-content>
              <v-list-item-title>View Product</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-model="active2"
          prepend-icon="mdi-alpha-c-box"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Customer</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/addCustomer" color="orange">
            <v-list-item-content>
              <v-list-item-title>Add Customer</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/customers" color="orange">
            <v-list-item-content>
              <v-list-item-title>View Customer</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-model="active3"
          prepend-icon="mdi-alpha-s-box"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Sales</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/makeSale" color="orange">
            <v-list-item-content>
              <v-list-item-title>Make Sales</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/viewSale" color="orange">
            <v-list-item-content>
              <v-list-item-title>View Sales</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/saleReport" color="orange">
            <v-list-item-content>
              <v-list-item-title>Sales Report</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group v-model="active4" prepend-icon="mdi-cog" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/changePassword" color="orange">
            <v-list-item-content>
              <v-list-item-title>Change Password</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/editBusinessProfile" color="orange" v-if="getUser.role === 'admin'">
            <v-list-item-content>
              <v-list-item-title>Edit Business Profile</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/editUser" color="orange">
            <v-list-item-content>
              <v-list-item-title>Edit User Profile</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/manageStaff" color="orange" v-if="getUser.role === 'admin'">
            <v-list-item-content>
              <v-list-item-title>Manage Staff</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/manageSubscribtion" color="orange" v-if="getUser.role === 'admin'">
            <v-list-item-content>
              <v-list-item-title>Manage Subscription</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="secondary" @click="logout()"> Logout </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    selectedItem: 0,
    drawer: null,
    active1: true,
    active2: true,
    active3: true,
    active4: false,

    items: [
      {
        action: "mdi-alpha-p-box",
        active: true,
        items: [
          { title: "Add Product", to: "/addProduct" },
          { title: "View Product", to: "/product" },
        ],
        title: "Products",
      },
      {
        action: "mdi-alpha-c-box",
        active: true,
        items: [
          { title: "Add Customer", to: "/addCustomer" },
          { title: "View Customer", to: "/customers" },
        ],
        title: "Customers",
      },

      {
        action: "mdi-alpha-s-box",
        active: true,
        items: [
          { title: "Make Sales", to: "/makeSale" },
          { title: "View Sales", to: "/viewSale" },
          { title: "Sales Report", to: "/saleReport" },
        ],
        title: "Sales",
      },
      {
        action: "mdi-cog",
        active: false,
        items: [
          { title: "Change Password", to: "/changePassword" },
          { title: "Edit Business Profile", to: "/editBusinessProfile" },
          { title: "Edit User Profile", to: "/editUser" },
          { title: "Manage Staff", to: "/manageStaff" },
          { title: "Manage Subscription", to: "/manageSubscribtion" },
        ],
        title: "Settings",
      },
    ],
  }),

  computed: {
    ...mapGetters(["getUser", "currentUser"]),
  },

  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style   scoped>
.border {
  background: #2f4ffe;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  text-decoration: none;
}
.border b:nth-child(1) {
  position: absolute;
  top: -20px;
  height: 20px;
  width: 100%;
  background: #2f4ffe;

  display: none;
}
.border b:nth-child(1)::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-bottom-right-radius: 20px;
  background: white;
}
.border b:nth-child(2) {
  position: absolute;
  bottom: -20px;
  height: 20px;
  width: 100%;
  background: #2f4ffe;
  display: none;
}
.border b:nth-child(2)::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top-right-radius: 20px;
  background: white;
}
.border b:nth-child(1),
.border b:nth-child(2) {
  display: block;
}
</style>